<template>
  <div v-if="opqIf">
    <infobulle :descriptionPopup="descriptionPopup">
      <v-checkbox
        :style="{ width: noLabel ? 'auto' : width + 'px' }"
        :input-value="innerValue"
        :true-value="true"
        :false-value="false"
        @change="handleChange"
        :rules="caseRules"
        :loading="updating"
        :disabled="updating || disabled"
      >
        <template v-if="!noLabel" v-slot:label><span v-html="libelleLong"></span></template>
      </v-checkbox>
    </infobulle>
  </div>
</template>
   

<script>
import ChampBase from "@/mixins/ChampBase"
import { Api, Queue } from "@/plugins/api"
// @group Champs
export default {
  data() {
    return {
      updating: false,
      innerValue: undefined
    }
  },

  props: {
    width: { type: String, default: "700" },
    value: Boolean,
    code: { type: String, required: false },
    noLabel: { type: Boolean, default: false },
    optional: { type: Boolean, default: false },
    live: { type: Object, default: undefined },
    // Variable qui lorsqu'elle passe à false, déclenche un clear du champ
    opqIf: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    id: { type: String }
  },

  mixins: [ChampBase],
  created() {
    this.innerValue = this.value
  },
  computed: {
    caseRules() {
      return [(v) => this.optional || !!v || "Obligatoire"]
    }
  },

  methods: {
    handleChange(event) {
      if (this.live) {
        this.updating = true
        Queue.enqueue(() =>
          Api.post(this.live.endpoint, {
            fileId: this.live.fileId,
            cle: this.live.cle,
            value: event
          }).finally(() => {
            this.$emit("eudo-updated", event)
            this.updating = false
            this.innerValue = event
          })
        )
      }
      this.$emit("input", event)
    },
    setValue(value) {
      this.innerValue = value
      this.handleChange(value)
    }
  },

  watch: {
    opqIf(newValue) {
      if (!newValue) {
        this.handleChange(false)
      }
    },
    value(newValue) {
      this.innerValue = newValue
    }
  }
}
</script>

<style>
</style>